import { useState, useCallback } from 'react';
import { getWireTransferHistory } from '../../services/invoiceService';

const useWireTransferHistory = () => {
  const [wireTransfers, setWireTransfers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchWireTransfers = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getWireTransferHistory();
      setWireTransfers(data);
    } catch (err) {
      if (err.response) {
        setError(`${err.response.data.message}`);
      } else if (err.request) {
        setError('Error: No response from server');
      } else {
        setError(`Error: ${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  return { wireTransfers, loading, error, fetchWireTransfers };
};

export default useWireTransferHistory;
